// extracted by mini-css-extract-plugin
module.exports = {"component":"paymentMethods_component__C2eYS","content":"paymentMethods_content__POdx5","entries":"paymentMethods_entries__FeKgf","entryImg":"paymentMethods_entryImg__zwRh8"};